

// this is a helper for the automation
var alertOrig = window.alert;
var confirmOrig = window.confirm;
window.alert = function(message) {
    if(sessionStorage.getItem('selenium') == "yes"){
        return true;
    }
    else {
        return alertOrig.apply(this, [message]);
    }
};
window.confirm = function(message) {
    if(sessionStorage.getItem('selenium') == "yes"){
        return true;
    }
    else {
        return confirmOrig.apply(this, [message]);
    }
};